import type {
  FullTextConstraint,
  HotelConstraint,
} from '@libs/constraint-builder';
import { serializeConstraint } from '@libs/constraint-builder';
import type { AccommodationType } from '@libs/trip-planner-interfaces';
import type { QueryString } from '@libs/utils';
import { renderQuery } from '@libs/utils';

import type { GetHotelsEndpointIncludedProperties } from './types';

export function getHotelsUrlBuilder(
  constraint: HotelConstraint,
  hotelTypes: AccommodationType[],
  includedProperties: GetHotelsEndpointIncludedProperties
): string {
  const shouldAddHotelTypesToQuery = (
    accomodationType: AccommodationType[]
  ): boolean => {
    const accommodationTypesAmount = 3;
    return (
      accomodationType.length > 0 &&
      accomodationType.length !== accommodationTypesAmount
    );
  };

  const fullTextConstraint = constraint.selection as FullTextConstraint;
  const query: QueryString = {
    SearchText: [serializeConstraint(constraint)],
    ...(constraint.hotelName && {
      AdditionalSearchText: [constraint.hotelName],
    }),
    Include: includedProperties.includeValues,
    ...(includedProperties.includeGroupValues.length && {
      IncludeGroup: includedProperties.includeGroupValues,
    }),
    ...(constraint.maxNumberOfHotels && {
      MaxNumberOfHotels: [constraint.maxNumberOfHotels.toString()],
    }),
    ...(fullTextConstraint?.perfectMatchOnly && {
      PerfectMatchOnly: ['true'],
    }),
    ...(shouldAddHotelTypesToQuery(hotelTypes) && {
      HotelTypes: hotelTypes,
    }),
  };

  return `Hotels/GetHotels?${renderQuery(query)}`;
}
